import {
  ChangeDetectionStrategy,
  Component,
  HostListener,
  signal,
} from '@angular/core';

@Component({
  selector: 'lib-fullscreen',
  template: `
    <button
      class="fullscreen-button"
      type="button"
      (click)="toggle()"
      [attr.aria-label]="isFullscreen() ? 'Exit full screen' : 'Full screen'"
      [attr.aria-pressed]="isFullscreen()"
    >
      <i
        class="pi"
        [class.pi-window-maximize]="!isFullscreen()"
        [class.pi-window-minimize]="isFullscreen()"
      ></i>
    </button>
  `,
  styleUrl: './fullscreen.less',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class Fullscreen {
  readonly isFullscreen = signal<boolean>(!!document.fullscreenElement);

  toggle(): void {
    if (document.fullscreenElement) {
      void document.exitFullscreen();
    } else {
      void document.documentElement.requestFullscreen();
    }
  }

  @HostListener('document:fullscreenchange')
  protected onFullscreenChange(): void {
    this.isFullscreen.set(!!document.fullscreenElement);
  }
}
